/**
 * Asking the chat composer for focus from elsewhere in the app. On desktop the
 * chat is the side panel beside every page, not a page to navigate to, so a
 * "go to chat" action (the command palette) brings focus to it instead.
 */
const listeners = new Set<() => void>();

/** Focus the chat composer of the mounted chat panel. */
export function focusChatComposer(): void {
  for (const listener of listeners) listener();
}

/** Called by the chat panel: run `listener` when focus is asked for; returns the unsubscribe. */
export function onChatComposerFocusRequest(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
